import styled from "styled-components"

import {TextButton} from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

export interface ArrowProps {
  isExpanded?: boolean,
  size?: number
}

export const ExpanderArrow = styled(Icon).attrs(({theme, size}) => ({
  size,
  color: theme.colors.greys.black,
  icon: IconTypes.chevronDown
}))<ArrowProps>`
  margin: ${({theme}) => theme.spacing.oneAndHalf};
  ${({isExpanded}) => isExpanded && "transform: rotate(180deg);"};
`

// Empty, but exporting so it can be extended on by programmer
export const ExpanderContent = styled.div``

interface WrapperProps {
  fullWidth?: boolean
}
export const HeaderWrapper = styled(TextButton)<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({fullWidth}) => fullWidth && "width: 100%;"}
  min-height: 48px;
`
